import { getCurrencyByKey } from '@wix/locale-dataset-javascript';
import { Decimal } from 'decimal.js';
export var Money = function (_a) {
    var currencyCode = _a.currencyCode, _b = _a.locale, locale = _b === void 0 ? 'en-US' : _b, _c = _a.amount, amount = _c === void 0 ? new Decimal(0) : _c;
    var fraction = getCurrencyByKey(currencyCode).fraction;
    var _locale = locale.replace('_', '-');
    var halfDown = function (_) {
        return _.toDecimalPlaces(fraction, Decimal.ROUND_HALF_DOWN);
    };
    var op = function (operator) { return function (value) {
        var result = amount[operator](value.decimalValue || value);
        return Money({ currencyCode: currencyCode, locale: locale, amount: halfDown(result) });
    }; };
    return {
        plus: op('plus'),
        minus: op('minus'),
        div: op('div'),
        times: op('times'),
        get decimalValue() {
            return amount;
        },
        get formatted() {
            return new Intl.NumberFormat(_locale, {
                currency: currencyCode,
                maximumFractionDigits: fraction,
                minimumFractionDigits: fraction,
                style: 'currency',
            }).format(amount.toNumber());
        },
    };
};
//# sourceMappingURL=index.js.map